import Icon from '../components/Icon.vue'

Icon.register({"bullhorn":{"width":576,"height":512,"paths":[{"d":"M576 224C576 203.1 562.6 185.3 544 178.7V64C544 28.7 515.3 0 480 0 415 56 338 128 208 128H48C21.5 128 0 149.5 0 176V272C0 298.5 21.5 320 48 320H91.3C72.5 384.6 93.7 436.4 110.1 487.4 111.8 492.8 115.3 497.3 120 500.3 140.8 513.5 188.4 516 213.8 505.5 229.8 498.8 233.7 478 221.3 465.9 202.8 447.9 191.2 429 201.5 405.1A12.3-12.3 0 0 1 200.5 393.4C184.1 368.7 196.9 331.3 229 320.7 346.4 327.9 418.6 395.1 480 448 515.3 448 544 419.3 544 384V269.3C562.6 262.7 576 244.9 576 224zM480 363.9C425.4 318.9 355 270.9 256 258.9V189.1C355 177.1 425.4 129.1 480 84.1V363.9z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/bullhorn.js
// module id = null
// module chunks = 